import React, { FC } from "react";
import { HexColor } from "../../../types/styles";
import { StyledBox, StyledInner, StyledOuter } from "./index.styled";

export interface MobileIconProps {
  isOpen: boolean;
  color?: HexColor;
}

export interface MobileMenuIconProps extends MobileIconProps {
  onClick: (isOpen: boolean) => void;
}

// This is the "Squeeze" hamburger from https://jonsuh.com/hamburgers/
export const MobileMenuIcon: FC<MobileMenuIconProps> = ({
  isOpen,
  color,
  onClick,
}) => {
  return (
    <StyledOuter onClick={() => onClick(!isOpen)}>
      <StyledBox>
        <StyledInner isOpen={isOpen} color={color} />
      </StyledBox>
    </StyledOuter>
  );
};
